import { addCommentToTheTicketAction } from "../../../Actions/LogicActions/ServiceRequestDetails/AddCommentToTheTicketAction";
import { closeServiceRequestAction } from "../../../Actions/LogicActions/ServiceRequestDetails/CloseServiceRequestAction";
import { getListOfServiceRequestAction } from "../../../Actions/LogicActions/ServiceRequestDetails/GetListOfServiceRequestAction";
import { getBookingDetailAction } from "../../../Actions/LogicActions/TicketDetail/GetBookingDetailAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { srReqClaimTree } from "../../../Orchestrator/ConstantTree/ServiceRequestClaim/ServiceRequestClaim";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ISaveServiceRequestDetailsResponse } from "../../../Orchestrator/Types/Interface/IServiceRequest";
import { IAddCommentToTheTicketActionParams } from "../../../Orchestrator/Types/Interface/IServiceRequestDetails";
import { ServiceRequestClaimDetailsContext } from "../Context/ServiceRequestClaimDetailsContext";

class ServiceRequestClaimDetailsInitStep extends StepFlow {
    get stepName() { return "ServiceRequestClaimDetailsInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: srReqClaimTree.RequestClaim.TicketList.Get,
                handler: async ({ data }) => {
                    const context = this.getCtx<ServiceRequestClaimDetailsContext>("serviceRequestClaimDetailsContext")
                    getListOfServiceRequestAction.setParams({ bookingId: data || "", screenFrom: "serviceRequestDetails" })
                    await getListOfServiceRequestAction.execute();
                    if (isActionRunSuccessfully(getListOfServiceRequestAction)) {
                        const result = getListOfServiceRequestAction.result
                        if (result?.status === "success") {
                            if (context) {
                                context.ticketList = result.data
                            }
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: srReqClaimTree.RequestClaimDetail.OpenAction,
                handler: async ({ data }) => {
                    updateRecoilState("openActionModalAtom", true);
                    updateRecoilState("actionTypeAtom", data || "");
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: srReqClaimTree.RequestClaimDetail.KeepAction,
                handler: async ({ data }) => {
                    updateRecoilState("openActionModalAtom", false);
                    updateRecoilState("actionTypeAtom", "");
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<number, void>({
                eventName: srReqClaimTree.RequestClaimDetail.CloseAction,
                handler: async ({ data }) => {
                    if (data) {
                        const context = this.getCtx<ServiceRequestClaimDetailsContext>("serviceRequestClaimDetailsContext")!
                        closeServiceRequestAction.setParams(data)
                        await closeServiceRequestAction.execute();
                        if (isActionRunSuccessfully(closeServiceRequestAction)) {
                            const result = closeServiceRequestAction.result
                            if (result?.status === "success") {
                                const oldTickets = (context.ticketList || []).map(ticket => {
                                    if (ticket.id === result.data.id) {
                                        return result.data
                                    }
                                    return ticket
                                })
                                updateRecoilState("serviceRequestTicketListAtom", oldTickets)
                                updateRecoilState("activeTicketAtom", result.data)
                                if (context) {
                                    context.ticketList = oldTickets
                                }
                            }
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<boolean, void>({
                eventName: srReqClaimTree.RequestClaimDetail.OpenCommentAction,
                handler: async ({ data }) => {
                    updateRecoilState("openCommentAtom", data || false)
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: srReqClaimTree.RequestClaimDetail.GetBooking,
                handler: async ({ data }) => {
                    if (data) {
                        getBookingDetailAction.setParams({ bookingId: data, screen: "" })
                        await getBookingDetailAction.execute();
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IAddCommentToTheTicketActionParams, void>({
                eventName: srReqClaimTree.RequestClaimDetail.AddComment,
                handler: async ({ data }) => {
                    if (data) {
                        const context = this.getCtx<ServiceRequestClaimDetailsContext>("serviceRequestClaimDetailsContext")
                        addCommentToTheTicketAction.setParams({ content: data.content, ticketId: data.ticketId })
                        await addCommentToTheTicketAction.execute();
                        if (isActionRunSuccessfully(addCommentToTheTicketAction)) {
                            const result = addCommentToTheTicketAction.result
                            if (result?.status === "success") {
                                const oldTickets = (data?.srTickets || []).map(ticket => {
                                    if (ticket.id === result.data.id) {
                                        return result.data
                                    }
                                    return ticket
                                })
                                updateRecoilState("serviceRequestTicketListAtom", oldTickets)
                                updateRecoilState("activeTicketAtom", result.data)
                                if (context) {
                                    context.ticketList = oldTickets
                                }
                            }
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<ISaveServiceRequestDetailsResponse, void>({
                eventName: srReqClaimTree.RequestClaimDetail.ActiveTicket,
                handler: async ({ data }) => {
                    if (data) {
                        updateRecoilState("activeTicketAtom", data)
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: srReqClaimTree.RequestClaimDetail.BackClick,
                handler: async ({ data }) => {
                    const bookingId = data
                    _eventBus.emit({
                        eventName: "FLOW_CLOSE",
                        data: "ServiceRequestClaimDetailsFlow"
                    })
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: bookingId ? "/bookings/details/" + bookingId : "/help"
                    })
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        const context = this.getCtx<ServiceRequestClaimDetailsContext>("serviceRequestClaimDetailsContext");
        if (!context) {
            //Set context if service-request-details page refresh
            this.setCtx("serviceRequestClaimDetailsContext", new ServiceRequestClaimDetailsContext());
        }
        _eventBus.emit({
            eventName: srReqClaimTree.RequestClaimDetail.FlowStarted
        })
        console.log("Service Request Claim Details Init Step Execute...........")
    }
}

export const ServiceRequestClaimDetailsInitStepDeclaration = new StepDefinition({
    stepName: "ServiceRequestClaimDetailsInit_Step",
    stepClass: ServiceRequestClaimDetailsInitStep
});